import React, { useState, useCallback, useRef } from "react";
import client from "../../../shared/api/client";
import { toastError } from "../../../shared/toastHelper";

const AddMatchDropdown = ({ teamId, eventId, onAdd }) => {
  const [query, setQuery] = useState("");
  const [results, setResults] = useState([]);
  const [searching, setSearching] = useState(false);
  const debounceRef = useRef(null);

  const search = useCallback(
    (searchQuery) => {
      if (debounceRef.current) clearTimeout(debounceRef.current);

      if (!searchQuery.trim()) {
        setResults([]);
        return;
      }

      debounceRef.current = setTimeout(async () => {
        setSearching(true);
        try {
          const response = await client.get(
            `/teams/${teamId}/calendar_events/${eventId}/available_meta_ads`,
            { params: { search: searchQuery } }
          );
          setResults(response.data);
        } catch {
          toastError("Failed to search ads");
          setResults([]);
        } finally {
          setSearching(false);
        }
      }, 300);
    },
    [teamId, eventId]
  );

  const handleChange = (e) => {
    const value = e.target.value;
    setQuery(value);
    search(value);
  };

  const handleAdd = (adId) => {
    onAdd(adId);
    setQuery("");
    setResults([]);
  };

  return (
    <div className="meta-social-ads__add-section">
      <input
        type="text"
        className="meta-social-ads__search-input"
        placeholder="Search ads to match..."
        value={query}
        onChange={handleChange}
      />
      {searching && <div className="meta-social-ads__loading">Searching...</div>}
      {results.length > 0 && (
        <div className="meta-social-ads__search-results">
          {results.map((group) => (
            <div key={group.campaignId} className="meta-social-ads__campaign-group">
              <div className="meta-social-ads__campaign-group-header">
                {group.campaignName}
              </div>
              {group.ads.map((ad) => (
                <div
                  key={ad.id}
                  className="meta-social-ads__ad-option"
                  onClick={() => handleAdd(ad.id)}
                >
                  <span>{ad.name}</span>
                  <span className="meta-social-ads__ad-status">{ad.status}</span>
                </div>
              ))}
            </div>
          ))}
        </div>
      )}
      {!searching && query.trim() && results.length === 0 && (
        <div className="meta-social-ads__no-matches">No matching ads found</div>
      )}
    </div>
  );
};

export default AddMatchDropdown;
